module.exports = __webpack_public_path__ + "media/images/gift/gift-step1-f6fc665912f6e885e609b800d5e15eb4.png";